import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            <div className="md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-fire-line text-background-50 text-lg"></i>
                </span>
                <span className="font-heading text-xl text-background-50">{siteInfo.name}</span>
              </Link>
              <p className="text-sm text-secondary-300 leading-relaxed">
                {siteInfo.tagline}
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">内容分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">关于我们</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                    联系我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">联系方式</h4>
              <ul className="space-y-2.5 text-sm text-secondary-300">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  {siteInfo.contact.email}
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-wechat-line"></i>
                  {siteInfo.contact.wechat}
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-weibo-line"></i>
                  {siteInfo.contact.weibo}
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-secondary-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-400">
              &copy; 2026 {siteInfo.name}. 版权所有 | 京ICP备2024XXXXXXXX号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
              <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}